/** Yaqin muddat: 7 / 14 / 30 kun */
import { useTranslation } from "react-i18next";
import type { Me } from "@/features/auth/types";
import { Select } from "@/components/ui/field";
import type { WidgetItem } from "../types";
import { FEE_DAYS, type FeesConfig } from "./index";

type Props = { item: WidgetItem<FeesConfig>; me: Me; onChange: (config: FeesConfig) => void };

export function FeesSettings({ item, onChange }: Props) {
  const { t } = useTranslation("widgets");
  return (
    <label className="block text-[12px] text-muted">
      {t("fees.daysLabel")}
      <Select value={String(item.config.days)} onChange={(e) => onChange({ days: Number(e.target.value) as FeesConfig["days"] })} className="mt-1">
        {FEE_DAYS.map((n) => (
          <option key={n} value={n}>
            {t("starts.days", { count: n })}
          </option>
        ))}
      </Select>
    </label>
  );
}
